import React from "react";
import {
  ApplianceType,
  LicenseManager,
  UIThemeContext,
  UIThemes
} from "@rl-appliances/component-library";
import useLicensing from "../hooks/useLicensing";
import useSecondaryLicensingId from "../hooks/useSecondaryLicensingId";
import { useCheckCloudConnection } from "../../../hooks";
import { ITestConnectionValues } from "../@types/licensing";

const Licensing = () => {
  const {
    localLicense,
    generateMachineId,
    uploadLicenseFile,
    configureTiCloud,
    tiCloudConfig,
    isLoading: isLocalLicenseLoading
  } = useLicensing();

  const { checkCloudConnection } = useCheckCloudConnection();
  const { secondaryLicensingId, isLoading: isSecondaryLicensingIdLoading } =
    useSecondaryLicensingId();

  if (!isLocalLicenseLoading && !isSecondaryLicensingIdLoading) {
    localLicense.secondaryLicensingId = secondaryLicensingId?.data?.machine_id;
  }

  const onTestConnection = async (values: ITestConnectionValues) => {
    const submitValues = {
      url: values.titaniumCloudUrl,
      user: values.username,
      token: values.password,
      timeout: values.requestTimeout,
      proxy_host: values.proxyHost,
      proxy_port: values.proxyPort,
      proxy_user: values.proxyUsername,
      proxy_password: values.proxyPassword
    };

    try {
      const response = await checkCloudConnection(submitValues);
      return {
        ...response,
        data: [
          {
            status: response.data.success ? "success" : "error",
            message: response.data.message
          }
        ]
      };
    } catch (error) {
      const response = error.response || {};
      const data = response.data || {};
      const fieldErrors = data?.detail?.fields || {};

      if (
        Object.keys(fieldErrors).length === 1 &&
        fieldErrors["non_field_errors"]
      ) {
        return [
          {
            status: "error",
            message: fieldErrors["non_field_errors"]
          }
        ];
      }

      if (Object.keys(fieldErrors).length > 0) {
        return [
          {
            status: "error",
            message: "Validation Failed",
            errors: fieldErrors
          }
        ];
      }

      return [
        {
          status: "error",
          message: "Failed to establish connection."
        }
      ];
    }
  };

  return (
    <UIThemeContext.Provider value={UIThemes.A1000}>
      <div className="Licensing--container">
        <LicenseManager
          localLicense={localLicense}
          tiCloudConfig={tiCloudConfig}
          configureTiCloud={configureTiCloud}
          generateMachineId={(license: any) =>
            generateMachineId(license.licensingId)
          }
          uploadLicenseFile={uploadLicenseFile}
          isLoading={isLocalLicenseLoading || isSecondaryLicensingIdLoading}
          appType={ApplianceType.A1000}
          licensingSupportEmailAddress={
            window.jsbridge.settings.LICENSING_SUPPORT_EMAIL
          }
          onTestConnection={onTestConnection}
        />
      </div>
    </UIThemeContext.Provider>
  );
};

export default Licensing;
